// extracted by mini-css-extract-plugin
export default {"divisor":"EventsSelector_divisor__ii9PD"};